import { createAction } from "@reduxjs/toolkit";
import { UPDATE_BASKET_LENGTH, UPDATE_CALENDAR_SALE_QNT_STATE, UPDATE_SELECT_SEATS } from "./basketTypes";
import { SelectedSeats } from "../../models/SelectedSeats";
import { QntStateItem } from "../../models/QntStateItem";

export const updateSelectedSeats = createAction<SelectedSeats[]>(UPDATE_SELECT_SEATS);
export const updateBasketLength = createAction<number>(UPDATE_BASKET_LENGTH);
export const updateCalendarSaleQntState = createAction<QntStateItem[]>(UPDATE_CALENDAR_SALE_QNT_STATE);
